import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlatpickrModule } from 'angularx-flatpickr';

import { BootstrapInputModule } from '@shared-modules/ng-bootstrap-input/bootstrap-input.module';
import { LoginComponent } from '@auth/login/login.component';
import { ComponentsModule } from '@shared-components/components.module';
import { LoaderModule } from '@shared-directives/loader/loader.module';

import { PatientIDLoginComponent } from './patient-login/patientID-login.component';
import { DemographicsLoginComponent } from './demographics-login/demographic-login.component';
import { SmartLinkLoginComponent } from './smart-link/smart-link.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        BootstrapInputModule,
        FlatpickrModule,
        CommonModule,
        BrowserModule,
        ComponentsModule,
        LoaderModule,
        NgxMaskDirective,
    ],
    declarations: [LoginComponent, PatientIDLoginComponent, DemographicsLoginComponent, SmartLinkLoginComponent],
    providers: [provideNgxMask()],
})
export class LoginModule {}
